import { useQuery } from 'react-query'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { getCart } from '../api'
import { ERROR_GETTING_CART } from '../errorConstants'

// CON-9232 Phase 3: read the cart payload that cartOrderAction injects into
// window.React.cart so useQuery starts in success state. Spinner gate at
// ConsumerCheckoutPage.js:2473 never engages on first render. Falls back to
// the existing fetch path when the payload is missing/invalid (guest user,
// empty cart, or server-side serialization failure).
const initialCart = (() => {
    try {
        return window.React?.cart ? JSON.parse(window.React.cart) : undefined
    } catch (e) {
        return undefined
    }
})()

const useFetchCart = () => {
    const { data, error, isLoading, isSuccess, isError } = useQuery(
        'cart',
        getCart,
        {
            initialData: initialCart,
            onError: (error) => {
                error.name = ERROR_GETTING_CART
                Sentry.captureException(error, {
                    contexts: {
                        data: {
                            errorMessage: "Error getting the user's cart",
                        },
                    },
                    user: {
                        id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                    },
                })
            },
            refetchOnWindowFocus: false,
        }
    )

    return { data, error, isLoading, isSuccess, isError }
}

export default useFetchCart
